import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Modal } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import cookie from "js-cookie";
import login from "./util/login";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import SnackBar from "../Common/SnackBar";
import GoogleLogin from "../Buttons/GoogleLogin";
import { makeStyles } from "@mui/styles";
import Logo from "../../Icons/Logo";
import Gradient from "../Buttons/Gradient";
import { withStyles } from "@mui/styles";
import eventBus from "../../util/eventBus";
import ReCAPTCHA from "react-google-recaptcha";
import Link from "next/link";

const recaptchaRef = React.createRef();

export default function LoginScreen(props) {
  //user messages
  const [loginError, setLoginError] = useState("");
  //inputs
  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [name, setName] = useState("");
  //errors
  const [usernameError, setusernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [inviteCodeError, setInviteCodeError] = useState("");
  const [nameError, setNameError] = useState("");

  const [isSignUp, setIsSignUp] = useState(false);
  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });
  const handleClose = () => {
    props.onClose();
  };
  const revalidate = () => {
    props.revalidate();
  };
  async function handleSubmit(e) {
    e.preventDefault();
    setusernameError("");
    setPasswordError("");
    setInviteCodeError("");
    setConfirmPasswordError("");
    setNameError("");
    setLoginError("");
    if (username == "" || username == null) {
      setusernameError("Enter Email/Mobile no");
      return false;
    }
    if (password == "" || password == null) {
      setPasswordError("Enter Password");
      return false;
    }
    if (!isSignUp) {
      fetch("https://admin.artistfirst.in/v1/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      })
        .then((r) => {
          return r.json();
        })
        .then((data) => {
          if (data && data?.error) {
            setusernameError("incorrect email or password.");
            setLoginError("Try again");
          }
          if (data && data?.code === 401) {
            setusernameError(data?.message);
            setLoginError("Try again");
          }
          if (data && data?.tokens) {
            //set cookie
            console.log("user is: ", data.user);
            cookie.set("token", data.tokens.refresh.token, { expires: 2 });
            login(
              data.tokens.access.token,
              data.user.name,
              data.user.email,
              data.user.id,
              data.user.role,
              data.user.roles
            );
            toggleSnackbar({
              show: true,
              status: "success",
              message: "Hi, You are logged in  " + data.user.name,
            });
            handleClose();
            if (props.callBackName || props.callBackName !== "") {
              eventBus.dispatch(props.callBackName);
              return;
            }
            // window.open("/nft/gold/jind-mahive");
          }
        })
        .catch((err) => {
          setusernameError(String(err));
        });
    } else {
      if (name == "" || name == null) {
        setNameError("Enter Name");
        return false;
      }
      if (confirmPassword == "" || confirmPassword == null) {
        setConfirmPasswordError("Enter Confirm Password");
        return false;
      }
      if (confirmPassword !== password) {
        setConfirmPasswordError("Password does not match");
        return false;
      }
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();

      fetch("https://admin.artistfirst.in/v1/user", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          email: username,
          password: password,
          role: "user",
          token: token,
        }),
      })
        .then((r) => {
          if (r.status == 201) {
            toggleSnackbar({
              show: true,
              status: "success",
              message: "Account created , please Login",
            });
            setIsSignUp(false);
          } else {
            return r.json();
          }
        })
        .then((data) => {
          if (data && data.code == 400) {
            // setusernameError(data.message);
            setLoginError(data.message);
            return false;
          }
        })
        .catch((err) => {
          setusernameError(String(err));
        });
    }
  }
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [snackbar, setSnackbar] = useState({
    show: false,
    status: "",
    message: "",
  });

  const toggleSnackbar = (value) => {
    setSnackbar(value);
  };

  const onCaptchaChange = (value) => {
    console.log("Captcha value:");
  };
  const handleIsSignUp = (e, val) => {
    e.preventDefault();
    setIsSignUp(val);
  };
  return (
    <>
      <Modal
        open={props.open}
        onClose={() => props.onClose()}
        className="scrollModal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="main-form-section">
          <button
            type="button"
            className="close clse-btn"
            style={{ color: "#fff" }}
            aria-label="Close"
            onClick={() => props.onClose()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="box">
            <div className="logo-login01">
              <img src="./images/home/fan_tiger_logo.png" alt="" />
            </div>
            <h2>{isSignUp ? "Sign Up" : "Login"}</h2>
            <p>Get early access and see your growth!</p>
            <form onSubmit={handleSubmit} autoComplete="off">
              {isSignUp && (
                <div className="inputBox">
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    name="name"
                    type="text"
                    placeholder="Name*"
                  />
                  {nameError && (
                    <span style={{ color: "red" }}>{nameError}</span>
                  )}
                </div>
              )}
              <div className="inputBox">
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setusername(e.target.value)}
                  name="username"
                  placeholder="Email/Mobile no*"
                />
                {usernameError && (
                  <span style={{ color: "red" }}>{usernameError}</span>
                )}
              </div>
              <div className="inputBox">
                <input
                  value={password}
                  type={values.showPassword ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  placeholder="Enter Password*"
                />
                {passwordError && (
                  <span style={{ color: "red" }}>{passwordError}</span>
                )}
              </div>
              {isSignUp && (
                <>
                  <div className="inputBox">
                    <input
                      name="confirmPassword"
                      value={confirmPassword}
                      type={values.showPassword ? "text" : "password"}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm Password*"
                    />
                    {confirmPasswordError && (
                      <span style={{ color: "red" }}>
                        {confirmPasswordError}
                      </span>
                    )}
                  </div>
                  {/* <div className="inputBox">
                    <input type="text"
                      placeholder="Enter Invite Code (if any)"
                    />
                  </div> */}
                </>
              )}
              {loginError && <p style={{ color: "red" }}>{loginError}</p>}
              {!isSignUp && (
                <div className="forget-password">
                  <Link href="/forgot-password">Forgot password?</Link>
                </div>
              )}
              <div className="login-button01">
                <button type="submit" className="btn">
                  {isSignUp ? "Sign up" : "Login"}
                </button>
                {isSignUp ? (
                  <p className="g-term">Or Sign up with Google</p>
                ) : (
                  <p className="g-term">Or Sign in with Google</p>
                )}
              </div>
              <div className="google-button01">
                <GoogleLogin
                  handleClose={handleClose}
                  text={
                    isSignUp ? "Sign up with Google" : "Sign in with Google"
                  }
                />
              </div>
              <div className="create-acc">
                {isSignUp ? (
                  <p>
                    Already have an account?
                    <a href="#" onClick={(e) => handleIsSignUp(e, false)}>
                      {" "}
                      Sign In{" "}
                    </a>
                  </p>
                ) : (
                  <p>
                    Not Registered yet?{" "}
                    <a href="#" onClick={(e) => handleIsSignUp(e, true)}>
                      Create an Account
                    </a>
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {snackbar.show ? (
        <SnackBar {...snackbar} onClose={toggleSnackbar} />
      ) : null}
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey="6LfV-WQfAAAAAA-jbkxkgzShlqBU6zImg4MZp05d"
        onChange={onCaptchaChange}
      />
    </>
  );
}
